import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "../assets/img/image.png";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";

import Img1 from "../assets/img/img2.png";
import TrackVisibility from "react-on-screen";

const Hero = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [
    "Web developer",
    "Frontend developer",
    "Web designer",
    "UI/UX designer",
    "DevOps Aspirant",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  id="home"
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>
                    {`Hey There! I'm Nandine , I'm a `}{" "}
                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Web developer","Frontend developer", "Web designer", "UI/UX designer",DevOps Aspirant ]'
                    >
                      <span className="wrap">
                        <br />
                        {text}
                      </span>
                    </span>
                  </h1>
                  <p>
                    Design and coding enthusiast with a keen interest in cloud
                    computing. Passionate about blending creativity with
                    technology for innovative solutions.
                  </p>
                  <button
                    class="connect"
                    onClick={() => console.log("connect")}
                  >
                    <a href="https://www.linkedin.com/in/nandine/">
                      {" "}
                      Let’s Connect{" "}
                    </a>
                    <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img
                    src="https://static.vecteezy.com/system/resources/thumbnails/044/448/931/small_2x/cartoon-character-with-the-desk-working-concept-illustration-free-png.png"
                    className="profile"
                    alt="Header Img"
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
